import axios from "axios"
import config from "../environments/generated.config"
import { mountApiUrl, mountHeaders, handleNotAuthenticated, handleLegacyResponse } from "./utils"
import { getSession } from "../providers/session"

export const default_cond_pag = "002"

const { base_url, dashboard, client_config } = config.apis.site

export async function getDashboard() {
  const { user_id, token, client_id } = getSession()
  const url = mountApiUrl(base_url, dashboard, { client_id, user_id })
  return handleNotAuthenticated(() => axios.get(url, mountHeaders(user_id, token)))
}

export async function clientConfig() {
  const { user_id, token, client_id } = getSession()
  const url = mountApiUrl(base_url, client_config, { client_id })
  const result = await handleLegacyResponse(
    () => axios.get(url, mountHeaders(user_id, token)),
    true
  )
  if (!result) {
    return {}
  }
  const {
    NOME: company,
    CONDPAG: cond_pag,
    PODEGRADE: grade_enabled,
    PODEPARAPAR: parapar_enabled,
    PODESURFACAGEM: surfacado_enabled,
    PODEMONTAGEM: montagem_enabled,
  } = result
  return {
    company,
    cond_pag: cond_pag || default_cond_pag,
    grade_enabled: Boolean(grade_enabled),
    parapar_enabled: Boolean(parapar_enabled),
    surfacado_enabled: Boolean(surfacado_enabled),
    montagem_enabled: Boolean(montagem_enabled),
  }
}
